import { useState } from 'react';
import Imatge from 'components/3catinfo/Imatge';
import Text from 'components/3catinfo/Text/Text';
import styles from '../cosNoticia.module.scss';
import clsx from 'clsx';

const ImatgeCos = (props) => {
    let { src, alt, peu } = props;
    const [imgLoaded, setImgLoaded] = useState(false);

    const stylesImatgeCos = clsx(styles.imatgeCos, imgLoaded && styles.imgLoaded);

    const imgHasLoaded = () => {
        setImgLoaded(true);
    };

    return (
        <div className={stylesImatgeCos} data-testid='cos-noticia-imatge'>
            <figure>
                <div className={styles.contentImg}>
                    <Imatge
                        src={src}
                        layout='fill'
                        objectFit='contain'
                        alt={alt}
                        className={styles.imgCos}
                        tipus='web_noti'
                        crop='1903'
                        checkisLoaded={imgHasLoaded}
                    />
                    {peu && (
                        <figcaption>
                            <Text text={peu} dataTestId='cos-noticia-imatge-peu' />
                        </figcaption>
                    )}
                </div>
            </figure>
        </div>
    );
};

export default ImatgeCos;
